import { isArray } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';

const mapTelephonyDataForForm = ({ userData = {}, groups, languageId }) => {
  const {
    name = {},
    user_groups,
    user_id: mitelUserId,
    dir_fields,
    organization,
    country_code,
    time_zone_id,
    authorize_search,
    ipad_support,
    premium_intrusion,
    premium_attendant,
    call_control_api,
    cloud_cti_api,
    line_state_api,
    crm_connect,
    unified_inbox,
    cloud_crm_connector,
    chat,
    teams_application,
    teams_telephony,
    teams_telephony_go,
    user_profile,
    cost_center,
    email,
    custom_id,
    answer_places,
    phone_numbers,
    web_softphone,
    mobile_voip,
    called_line_id
  } = userData;

  const allGroupsOptions = mapGroups(groups);

  const department = Optional(organization)
    .map(organization => organization.department)
    .or('');

  const dirFields = mapFields(dir_fields);

  const phoneNumbers = mapPhoneNumbers(phone_numbers || []);

  return {
    allGroupsOptions,
    groups: user_groups,
    generalData: {
      custom_id,
      email,
      cost_center,
      user_profile,
      ipad_support,
      premium_intrusion,
      premium_attendant,
      call_control_api,
      cloud_cti_api,
      line_state_api,
      crm_connect,
      unified_inbox,
      cloud_crm_connector,
      chat,
      teams_application,
      teams_telephony,
      teams_telephony_go,
      authorize_search,
      country_code,
      time_zone_id,
      dirFields,
      department,
      mitelUserId,
      firstName: name.given_name,
      lastName: name.family_name,
      language: languageId,
      answer_places,
      phoneNumbers,
      web_softphone,
      mobile_voip,
      called_line_id
    }
  };
};

export default mapTelephonyDataForForm;

const mapGroups = (groups = []) => {
  return groups.map(group => {
    return { isUserGroup: false, label: group.name };
  });
};

const mapFields = fields => {
  return fields.reduce((obj, field) => {
    const { id, value, label } = field;
    return { ...obj, [id]: { value, label } };
  }, {});
};

const mapPhoneNumbers = (phoneNumbers = []) => {
  const primaryLine = mapLine(phoneNumbers, 'PRIMARY');
  const secondaryLine = mapLine(phoneNumbers, 'SECONDARY');

  const faxLine = phoneNumbers.find(line => line.type === 'FAX') || {
    mobile_vpn: false,
    number_type: 'OFFICE_FIXED',
    type: 'FAX',
    value: ''
  };

  return {
    primaryLine,
    secondaryLine,
    faxLine
  };
};

const mapLine = (phoneNumbers, lineType) => {
  return Optional(phoneNumbers.find(line => line.type === lineType))
    .map(line => {
      return {
        ...line,
        aliases: isArray(line.aliases)
          ? line.aliases.map(alias => {
              return { ...alias, id: Date.now() };
            })
          : []
      };
    })
    .or({});
};
